module.exports = __webpack_public_path__ + "media/images/stock_groups/e8f9-6a9894a90a778122ecf783fa33a23600.svg";